/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/browser"/>

export function isWebAnimationsApiSupported(): boolean {
    return document.getAnimations !== undefined;
}